import { Box, Button, Drawer, IconButton, Typography } from "@mui/material"
import { useStyles } from "./styles"
import { icons } from "../../../../../../../utils/icons"
import { useTranslation } from "react-i18next"
import { ChildrenCoordinates } from "./types"
import { AcordionActivityMap } from "../acordionActivity"


const ActivityOnMap = ({ closeOrViewLess, children, openSeeMore }: { closeOrViewLess: () => void, children: ChildrenCoordinates[], openSeeMore: boolean }) => {

    const styles = useStyles()
    const { t } = useTranslation()

    return (<>

        <Drawer open={openSeeMore} anchor="right">
            <Box sx={styles.mainContainer}>
                <Box sx={styles.containerTtitle}>
                    <Typography variant='text_grey' fontWeight='bold' fontSize={16}>
                        {t('loogbook.titles.activitiesOnThisUnity')}
                    </Typography>
                    <IconButton
                        onClick={closeOrViewLess}
                    >
                        {icons('simple-close')}
                    </IconButton>
                </Box>

                <Box sx={styles.activities}>
                    {
                        children.map((child) => (
                            <AcordionActivityMap child={child} />
                        ))
                    }
                </Box>

                <Box sx={styles.containerButon}>
                    <Button onClick={closeOrViewLess}>{t('loogbook.buttons.close')}</Button>
                </Box>
            </Box>
        </Drawer>
    </>)
}

export { ActivityOnMap }